import { ButtonPrimary, ButtonSecondary } from "@nova/component-btn"
import { HighPriorityNovaModalContainer } from "@nova/component-nova-modal-container"
import * as Icons from "@nova/component-icons"
import { useEffect } from "react"
import { useAppDispatch } from "integrations/redux/hooks"
import { hideGlobalModal } from "runlevel/actions"

const WelcomeTips = [
    {
        title: "Check out the Learn Center",
        body: "If it's your first time on Nova, or you have questions about using specific add-ons, the Learn Center is a great place to start.",
        buttonTitle: "Learn Center",
        icon: Icons.LocalLibrary,
        url: "https://learn.mapnova.com",
    },
    {
        title: "Collection Best Practices",
        body: "We've dedicated countless hours to gathering data and learning what works best to create a great map. So we've compiled all our tips and tricks.",
        buttonTitle: "Best Practices PDF",
        icon: Icons.CardsStar,
        url: "https://cdn.mapnova.com/8d6373f5/Data_Collection_Best_Practices.pdf",
    },
    {
        title: "Download Sample Data",
        body: "In the very beginning of your drone mapping journey? We've got you covered. Download our sample data to test out our features!",
        buttonTitle: "Sample Data",
        icon: Icons.ArrowCoolDown,
        url: "https://www.mapnova.com/learn/sample-data",
    },
]

/** @deprecated */
export const WelcomeToNovaModal = () => {
    const dispatch = useAppDispatch()
    //the first time this gets shown, turn off the flag to show the modal so it never appears again
    useEffect(() => {
        localStorage.setItem("showTutorialModal", JSON.stringify(false))
    }, [])

    return (
        <HighPriorityNovaModalContainer
            title="Wecome to Nova"
            className="!w-max max-w-[960px]"
            bottomBar={
                <div className="w-full flex justify-end items-center gap-2">
                    <ButtonPrimary
                        title="Maybe Later"
                        RightIcon={Icons.ArrowRight}
                        onClick={() => dispatch(hideGlobalModal())}
                    />
                </div>
            }
            closeModal={() => dispatch(hideGlobalModal())}
        >
            <div className="text-[36px] leading-[42px] text-gray-0 mt-6 mb-[34px]">
                Tips for getting started.
            </div>
            <div className="flex gap-8">
                {WelcomeTips.map((tip, idx) => (
                    <WelcomeItem {...tip} key={idx} />
                ))}
            </div>
        </HighPriorityNovaModalContainer>
    )
}

const WelcomeItem = ({
    title,
    icon: Icon,
    body,
    buttonTitle,
    url,
}: {
    title: string
    icon: Icons.IconComponent
    body: string
    buttonTitle: string
    url: string
}) => {
    return (
        <div className="flex flex-col gap-4">
            <Icon className="text-lazeryellow" />
            <div className="text-gray-0 text-[21px] whitespace-nowrap">{title}</div>
            <div className="text-gray-100 text-[16px] leading-[24px]">{body}</div>
            <ButtonSecondary
                title={buttonTitle}
                onClick={() => {
                    window.open(url, "_blank")
                }}
                RightIcon={Icons.OpenInNew}
                className="w-max"
            />
        </div>
    )
}
